import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';
import { TAgentFirmListResponse } from './types';

type UseAgentFirmsOptions = {
  search?: string;
  enabled?: boolean;
};

export function useAgentFirms(options?: UseAgentFirmsOptions) {
  const { search, enabled = true } = options ?? {};

  const query = new URLSearchParams();
  if (search) {
    query.append('search', search);
  }

  const queryString = query.toString();
  const url = queryString ? `${API_BASE_PATH}?${queryString}` : API_BASE_PATH;

  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data?: TAgentFirmListResponse;
    error?: unknown;
    mutate: KeyedMutator<TAgentFirmListResponse>;
    isLoading: boolean;
  } = useSWR(
    enabled ? url : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data: data?.agentFirms ?? [],
    count: data?.count ?? 0,
    error,
    mutate,
    isLoading,
  };
}
